<template>
	<v-container grid-list-md>
		<v-card flat>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12>
						<v-subheader>
							<strong>
								<v-icon left>mdi-currency-usd</v-icon>
								{{ $t("label.open_exchange") }}
							</strong>
						</v-subheader>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.open_exchange_rate_key"
							:label="$t('label.open_exchange_rate_key')"
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-subheader>
							<strong>
								<v-icon left>mdi-telegram</v-icon>
								{{ $t("label.telegram") }}
							</strong>
						</v-subheader>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.telegram_bot_token"
							:label="$t('label.telegram_bot_token')"
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-subheader>
							<strong>
								<v-icon left>mdi-bird</v-icon>
								{{ $t("label.messagebird") }}
							</strong>
						</v-subheader>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.messagebird_access_key"
							:label="$t('label.messagebird_access_key')"
						></v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.messagebird_originator"
							:label="$t('label.messagebird_originator')"
						></v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.messagebird_recipients"
							:label="$t('label.messagebird_recipients')"
						></v-text-field>
					</v-flex>

					<v-flex xs12>
						<v-subheader>
							<strong>
								<v-icon left>mdi-cogs </v-icon>
								{{ $t("label.pusher") }}
							</strong>
						</v-subheader>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.pusher_app_id"
							:label="$t('label.pusher_app_id')"
						></v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.pusher_app_key"
							:label="$t('label.pusher_app_key')"
						></v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.pusher_app_secret"
							:label="$t('label.pusher_app_secret')"
						></v-text-field>
					</v-flex>
					<v-flex xs12 md4>
						<v-text-field
							v-model="item.pusher_app_cluster"
							:label="$t('label.pusher_app_cluster')"
						></v-text-field>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					@click="submit()"
					color="primary"
					:loading="item.processing"
				>
					<v-icon left>mdi-content-save</v-icon>
					{{ $t("Save") }}</v-btn
				>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
import CentralLayout from "../../../layouts/central.vue";
import CentralSettingLayout from "../../../layouts/partials/central/setting.vue";
export default {
	layout: [CentralLayout, CentralSettingLayout],

	props: ["data"],

	data() {
		return {
			item: this.$inertia.form(this.data),
		};
	},

	methods: {
		async submit() {
			try {
				this.item.post(
					this.$route("central.settings.store", {
						key: "service",
					})
				);
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
};
</script>